import Instance from "../../../Axios";

const GetPlusTipoTarifas = () => async (dispatch) => {
  await Instance()
    .get(`/plus/adesoes/data/tipoTarifas`)
    .then(({ data }) => {
      dispatch({ type: "GET_PLUS_TIPO_TARIFAS", payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetPlusTipoTarifas;
